import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { buildInitialFiltersFromSearch } from "@/utils/urlFilterParams";

import { oaBaseFilter } from "../../oa.constants";
import { OA_QUERY_FILTER_MAPPINGS } from "../../oa-query-schema";

export default function useOAFilterQueryState() {
	const location = useLocation();

	const { initialBaseFilter, hasExplicitDateFilters } = useMemo(() => {
		const { filters, hasUrlFilters } = buildInitialFiltersFromSearch(oaBaseFilter, location.search, OA_QUERY_FILTER_MAPPINGS);

		return {
			initialBaseFilter: filters,
			hasExplicitDateFilters: hasUrlFilters && (location.search.includes("date_start=") || location.search.includes("date_end=")),
		};
	}, [location.search]);

	return {
		initialBaseFilter,
		hasExplicitDateFilters,
	};
}
